module.exports = __webpack_public_path__ + "img/rent.c618ba4a.svg";